const API_KEY = "apikey";
const KEYCLOAK_TOKEN = "token";

export const LS_ELEMENTS = {
  API_KEY: API_KEY,
  KEYCLOAK_TOKEN: KEYCLOAK_TOKEN,
};

export const getLSData = (key) => {
  return localStorage.getItem(key) || null;
};

export const setLSData = (key, val) => {
  if (val !== 0 && !val) clearLSData();
  else localStorage.setItem(key, val);
  return 1;
};

export const clearLSData = (key) => {
  localStorage.removeItem(key);
};

export const clearAllLSData = () => {
  Object.assign(LS_ELEMENTS).map((v) => clearLSData(v));
};

export const clearAllSessionStorageData = () => {
  sessionStorage.removeItem("back_communication_hub");
  sessionStorage.removeItem("back_document");
  sessionStorage.removeItem("supplier_id");
  sessionStorage.removeItem("po_id");
  sessionStorage.removeItem("po_line_id");
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("logistic_tab");
  sessionStorage.removeItem("back_logistic_tab");
};

export const setAuthUserOnboarding = (user) =>
  sessionStorage.setItem("auth-user", JSON.stringify(user));

export const getAuthUserOnboarding = () => {
  const user = sessionStorage.getItem("auth-user");
  return user ? JSON.parse(user) : null;
};
